import React from 'react';
import { Skeleton, type SkeletonProps } from '@chakra-ui/react';

/**
 * On-brand skeleton. Chakra's default skeleton is a flat, cool grey (`bg.emphasized`) with barely
 * rounded corners — it reads as foreign against this app's soft, translucent, heavily-rounded
 * surfaces. This wrapper swaps in a gentle surface-adaptive tint (translucent black in light, white
 * in dark, so it sits naturally on any card) and rounder corners, then keeps the default opacity
 * pulse.
 *
 * When to reach for it: a skeleton is honest only for a *fast, known-shape* load — reserve the
 * resolved layout's silhouette and it reads as "your content, arriving". For indeterminate or slow
 * waits, or where there's no real shape to promise yet (e.g. generating something that doesn't
 * exist), prefer a spinner: a lingering skeleton makes the app own the wait, whereas a spinner reads
 * as neutral "loading" the user attributes to the network.
 */
// Hoisted so the conditional-value object isn't re-allocated on every skeleton render (they can
// appear per chat citation / per thumbnail).
const SKELETON_BG = { base: 'blackAlpha.200', _dark: 'whiteAlpha.200' } as const;

export const AppSkeleton: React.FC<SkeletonProps> = (props) => (
	<Skeleton borderRadius="xl" bg={SKELETON_BG} {...props} />
);

export default AppSkeleton;
